import Image from 'next/image'
import React from 'react'
import DefaultImage from '#/assets/images/blog/default.png'
import cn from '#/utils/classnames'
import { News } from '../types'

const CoverImage: React.FC<News.CoverImageProps> = ({
  title,
  coverImage,
  slug
}) => {
  const image = (
    <div className='relative transform duration-500 ease-in-out xs:hover:-translate-y-px xs:hover:scale-105'>
      <div className={cn('rounded-t-xl bg-gray-100 object-cover w-full relative', 'h-auto 2xs:h-[16rem]')}>
        <Image
          alt={title || 'Cover'}
          className='h-full w-full object-cover'
          fill
          quality={100}
          sizes='374px'
          src={coverImage?.sourceUrl || DefaultImage}
        />
      </div>
    </div>
  )

  return (
    <div className='sm:mx-0'>
      {slug ? <span aria-label={title}>{image}</span> : image}
    </div>
  )
}

export default CoverImage
